import React, { ChangeEvent, useState } from 'react'
import { useStore } from 'effector-react'
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CRow,
} from '@coreui/react-pro'
import { $error, $offer, setOfferForm, submitCreateOffer } from './model'

export const CreateOffer: React.FC = () => {
  const [validated, setValidated] = useState(false)

  const offer = useStore($offer)
  const error = useStore($error)

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }

    setOfferForm({
      ...offer,
      [event.currentTarget.name]: value,
    })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      submitCreateOffer(offer)
      event.preventDefault()
      event.stopPropagation()
    }
    setValidated(true)
  }

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Create offer</strong>
      </CCardHeader>
      <CCardBody>
        {error.message.length > 0 && (
          <CAlert color="danger">Error: {error.message}</CAlert>
        )}
        <CForm noValidate validated={validated} onSubmit={handleSubmit}>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormInput
                type="text"
                name="title"
                value={offer.title}
                onChange={handleChange}
                label="Name"
                minLength={3}
                maxLength={30}
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormCheck
                name="isVisible"
                checked={offer.isVisible}
                onChange={handleChange}
                label="Active"
              />
            </CCol>
          </CRow>
          <CButton className="mb-3" type="submit">
            Save
          </CButton>
        </CForm>
      </CCardBody>
    </CCard>
  )
}
